// @ts-nocheck
import {ConfEnv} from "../../../../../../config/config";
import privateRequest from "../../../../../../Infra/http/private.request";

export const getLotteryTicketsService = () => {
  return privateRequest.get(`${ConfEnv.BASE_URL}/lottery/tickets`);
};
